import { render, staticRenderFns } from "./FormCreate.vue?vue&type=template&id=ed9401b4"
import script from "./FormCreate.vue?vue&type=script&lang=js"
export * from "./FormCreate.vue?vue&type=script&lang=js"
import style0 from "./FormCreate.vue?vue&type=style&index=0&id=ed9401b4&prod&lang=css"
import style1 from "./FormCreate.vue?vue&type=style&index=1&id=ed9401b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports